import React, { useEffect, useState } from "react";
import LoginOther from "./Components/LoginOther";
import LoginForm from "./Components/LoginForm";
import RegisterForm from "./Components/RegisterForm";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Auth/AuthProvider";
import logo from "../../logo-light.svg";
import Overlay from "../../Components/Overlay/Overlay";
import TextDivider from "../../Components/TextDivider/TextDivider";
import { userHomePath } from "../../routes";
import ForgotPasswordForm from "./Components/ForgotPasswordForm";

export default function Login() {
  const [usingEmail, setUsingEmail] = useState(false);
  const [emailErr, setEmailErr] = useState(false);

  const [usingGoogle, setUsingGoogle] = useState(false);
  const [googleErr, setGoogleErr] = useState(false);

  const [usingFacebook, setUsingFacebook] = useState(false);
  const [facebookErr, setFacebookErr] = useState(false);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated, loading } = useAuth();

  const clearAllErrors = () => {
    setEmailErr(false);
    setGoogleErr(false);
    setFacebookErr(false);
  };

  const handleLogin = (type, action) => {
    clearAllErrors();

    switch (type) {
      case "email":
        setUsingEmail(action);
        break;
      case "google":
        setUsingGoogle(action);
        break;
      case "facebook":
        setUsingFacebook(action);
        break;
      default:
        console.error(
          "No login method specified calling handleLogin() in Login.js",
        );
        break;
    }
  };

  const handleError = (type, message) => {
    switch (type) {
      case "email":
        setEmailErr(message);
        break;
      case "google":
        setGoogleErr(message);
        break;
      case "facebook":
        setFacebookErr(message);
        break;
      default:
        console.error(
          "No error type specified calling handleError() in Login.js",
        );
        break;
    }
  };

  const loginProps = {
    userHomePath,
    handleLogin,
    handleError,
  };

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate(userHomePath);
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="flex justify-center py-10 text-center">
      <div className="relative w-full max-w-md overflow-hidden rounded-sm border border-mauve-200 bg-white">
        {usingEmail || usingGoogle || usingFacebook ? <Overlay /> : null}

        <div className="px-6 pb-2 pt-8">
          <img src={logo} alt="faveback" className="mx-auto h-auto w-30" />
        </div>

        <div className="border-t border-mauve-100 px-6 py-6">
          <LoginOther
            variation="facebook"
            text="Continue with Facebook"
            {...loginProps}
            loggingIn={usingFacebook}
            error={facebookErr}
          />

          <LoginOther
            variation="google"
            text="Continue with Google"
            {...loginProps}
            loggingIn={usingGoogle}
            error={googleErr}
            className="mt-3"
          />

          <TextDivider text="or" />

          {pathname === "/login" && (
            <LoginForm
              {...loginProps}
              loggingIn={usingEmail}
              error={emailErr}
            />
          )}
          {pathname === "/register" && (
            <RegisterForm
              {...loginProps}
              loggingIn={usingEmail}
              error={emailErr}
            />
          )}
          {pathname === "/forgotPassword" && (
            <ForgotPasswordForm
              {...loginProps}
              loggingIn={usingEmail}
              error={emailErr}
            />
          )}
        </div>
      </div>
    </div>
  );
}
